import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Eye } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart, loading } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await addToCart(product.id);
      toast.success('Added to cart', {
        description: `${product.name} has been added to your cart.`
      });
    } catch (error) {
      toast.error('Error adding to cart');
    }
  };

  const handleQuickView = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/product/${product.id}`);
  };

  const hasDiscount = product.sale_price && product.sale_price < product.price;

  return (
    <div className="product-card group" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`}>
        {/* Image */}
        <div className="product-card-image relative">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
          />
          
          {hasDiscount && (
            <span className="badge-sale" data-testid="sale-badge">Sale</span>
          )}

          {/* Quick actions overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100">
            <button
              onClick={handleAddToCart}
              disabled={loading || !product.in_stock}
              className="bg-white p-3 rounded-full shadow-lg hover:bg-[#1A1A1A] hover:text-white transition-colors disabled:opacity-50"
              data-testid={`add-to-cart-${product.id}`}
            >
              <ShoppingCart size={20} />
            </button>
            <button
              onClick={handleQuickView}
              className="bg-white p-3 rounded-full shadow-lg hover:bg-[#1A1A1A] hover:text-white transition-colors"
              data-testid={`quick-view-${product.id}`}
            >
              <Eye size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-xs text-[#8B5E3C] font-medium uppercase tracking-wider mb-1">
            {product.style}
          </p>
          <h3 className="font-manrope font-semibold text-[#1A1A1A] mb-2 group-hover:text-[#8B5E3C] transition-colors">
            {product.name}
          </h3>
          <div className="flex items-center gap-2">
            {hasDiscount ? (
              <>
                <span className="price-sale text-lg">${product.sale_price.toFixed(2)}</span>
                <span className="price-original">${product.price.toFixed(2)}</span>
              </>
            ) : (
              <span className="font-semibold text-lg text-[#1A1A1A]">${product.price.toFixed(2)}</span>
            )}
          </div>
          
          {!product.in_stock && (
            <p className="text-sm text-red-500 mt-2">Out of Stock</p>
          )}
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
